import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';

const Rep_stock_valuation = (props) => {
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const HOCODE = sessionStorage.getItem('hocode');
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    //----------------------------------------------------------------------------------------------REPORT HEADER USES  
    const [headerProduct, setHeaderProduct] = useState("");
    const [headerIsd, setHeaderIsd] = useState("");
    const [headerBranch, setHeaderBranch] = useState("");
    const [headerValuation, setHeaderValuation] = useState("");
    const [headerGroup, setHeaderGroup] = useState("");
    const [headerAccount, setHeaderAccount] = useState("");
    //--------------------------------------------------------------------------------------------------MSG BOX 
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    //--------------------------------------------------------------------------------------------------MAIN SCREEN FILTERS
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [counter, setCounter] = useState(0);
    const [filterBalanceBookType, setFilterBalanceBookType] = useState("T");
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [hdrSrno, setHdrSrno] = useState("");
    //--------------------------------------------------------------------------------------------------SCREEN MODE 
    const [scrMode, setScrMode] = useState("");

    //--------------------------------------------------------------------------------------------------TABLES
    const [activityLogData, setActivityLogData] = useState([]);

    const [cnEvtmGroupWiseData, setCnEvtmGroupWiseData] = useState([]);
    const [cnEvtmIsdWiseData, setCnEvtmIsdWiseData] = useState([]);
    const [cnEvtmIsdToBranchWiseData, setCnEvtmIsdToBranchWiseData] = useState([]);
    const [cnEvtmIsdCalculationData, setCnEvtmIsdCalculationData] = useState([]);
    const [cnEvtmBranchWiseData, setCnEvtmBranchWiseData] = useState([]);
    const [cnEvtmBranchToIsdWiseData, setCnEvtmBranchToIsdWiseData] = useState([])
    const [cnEvtmBranchToIsdWiseCalculationData, setCnEvtmBranchToIsdWiseCalculationData] = useState([])


    const [onceRun, setOnceRun] = useState(false);

    var msg = [], i = 0;

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_STOCK_VALUATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleLocationType = (e) => {
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }
    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }
    const generateObjectCNEVTM = (filtercn, filtervtm, filterevtm, srno) => {
        var obj = {
            srno: srno,
            filterLocationType: filterLocationType,
            radioTypeLocation: filterLocationType,
            location: locationCode,
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            tillDate: Common.dateYMD(toDate),
            filterBalanceBookType: filterBalanceBookType,
            repLevelGlobal: filterLocationType == "A" ? true : false,
            repLevelLocal: true,
            showHeader: false,
            filterCN: filtercn,
            filterVTM: filtervtm,
            filterEVTM: filterevtm,
            filterDD: false,
            filterTT: false,
        }
        return obj;
    }
    //------------------------------------------------------------------------------------------------------------------BALANCE BOOK GENERATION
    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        }

        setScrMode('REPORT_GENERATION')
        if (fromDate == null || toDate == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate == null ? "Please select from date." : '');
            msg[i++] = (toDate == null ? "Please select to date." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            handleRightsCheck();
        }
    }
    const handleRightsCheck = () => {
        var msg = [], i = 0;
        Promise.all([
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'REP_VALUATION_GLOBAL']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'REP_VALUATION_LOCAL']),
        ])
            .then(([valuationGlobal, valuationLocal]) => {
                if (valuationGlobal.query === '0') {
                    msg[i++] = ("Rights Not Allowed for Rep Global Valuation");
                }
                if (valuationLocal.query === '0') {
                    msg[i++] = ("Rights Not Allowed for Rep Local Valuation");
                }
                if (i > 0) {
                    setScrMode("");
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                } else {
                    handleGenerateRequest(i, msg);
                }
            })
            .catch(error => alert(error));
    }
    const handleGenerateRequest = (i, msg) => {
        msg[i++] = ("Stock Valuation Generating...");
        setMsgText(Common.buildMessageFromArray(msg));
        setMsgBox(true);
        const obj = {
            location: locationCode,
            fromDate: filterBalanceBookType === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : filterBalanceBookType === 'P' ? Common.dateYMD(fromDate) : startDate,
            toDate: filterBalanceBookType === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : Common.dateYMD(toDate),
            tillDate: Common.dateYMD(toDate),
            filterBalanceBookType: filterBalanceBookType,
            filterLocationType: filterLocationType,
            location: locationCode,
            showHeader: false,
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "insertactivitylog", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setHdrSrno(resp.srno);
            insertCNEVTM(resp, i, msg);
        })

    }
    //                                                                                              CN/VTM/EVTM BALANCE BOOK GENERATION ----STOCK VALUATION
    const insertCNEVTM = (resp, i, msg) => {
        const objCN = generateObjectCNEVTM(true, false, false, resp.srno);
        const objVTM = generateObjectCNEVTM(false, true, false, resp.srno);
        const objEVTM = generateObjectCNEVTM(false, false, true, resp.srno);
        Promise.all([
            Common.callApiPromise(Common.apiRepStockValuation, [sid, 'currencyinsertion', JSON.stringify(objCN), resp.srno]),
            Common.callApiPromise(Common.apiRepStockValuation, [sid, 'vtminsertion', JSON.stringify(objVTM), resp.srno]),
            Common.callApiPromise(Common.apiRepStockValuation, [sid, 'evtminsertion', JSON.stringify(objEVTM), resp.srno]),
        ])
            .then(([iscurrencyinserted, isvtminserted, isevtminserted]) => {
                if (iscurrencyinserted.msg === "MSG0000" && isvtminserted.msg === "MSG0000" && isevtminserted.msg === "MSG0000") {
                    msg[i++] = ("CN/EVTM/VTM Balance Sheet Generated .");
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                    $(".loader").hide();
                } else {
                    setMsgText("CN/EVTM/VTM  Balance Sheet Generation Failed");
                    setMsgBox(true);
                    $(".loader").hide();
                }
            })
            .catch(error => alert(error));
    }
    //------------------------------------------------------------------------------------------------------------------BACK BUTTONS 
    const handleBackScreenReportGeneration = (previousscreenmode) => {
        setScrMode(previousscreenmode);
    }
    //------------------------------------------------------------------------------------------------------------------REPORT LOG 
    const handleReportLog = () => {
        const obj = {
            fromDate: filterBalanceBookType === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : filterBalanceBookType === 'P' ? Common.dateYMD(fromDate) : startDate,
            toDate: filterBalanceBookType === 'O' ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() - 1)).toISOString().split("T")[0] : Common.dateYMD(toDate),
            filterLocationType: filterLocationType,
            location: locationCode,
            filterBalanceBookType: filterBalanceBookType,
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "activitylogview", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setActivityLogData(resp.activitylogdata);
            setScrMode('ACTIVITY_LOG');
        })
    }
    const handleActivityLogDetail = (srno) => {
        setHdrSrno(srno);
        setScrMode('REPORT_GENERATION');
    }
    //------------------------------------------------------------------------------------------------------------------STOCK VALUATION 
    const handleCNVTMEVTMView = () => {
        $(".loader").show();
        Common.callApi(Common.apiRepStockValuation, [sid, "cnevtmviewgroupby", hdrSrno], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmGroupWiseData(resp.cnEvtmGroupByData);
            $(".loader").hide();
            setScrMode("CNEVTM_VIEW")
        })
    }
    const handleCnEvtmIsdWiseView = (srno, product, valuation) => {
        setHeaderProduct(product);
        setHeaderValuation(valuation);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "cnEvtmIsdWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmIsdWiseData(resp.cnevtmisdwisedata);
            setScrMode("CNEVTM_ISD_WISE")
            $(".loader").hide();
        })
    }
    const handleCnEvtmIsdToBranchWiseView = (srno, product, branch, isd, valuation) => {
        setHeaderValuation(valuation)
        setHeaderIsd(isd);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
            branchCode: branch,
            isd: isd
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "cnEvtmIsdToBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmIsdToBranchWiseData(resp.cnevtmisdtobranchwisedata);
            setScrMode("CNEVTM_ISD_TO_BRANCH_WISE")
            $(".loader").hide();
        })
    }
    const handleCnEvtmIsdCalculations = (srno, product, branch, isd, valuation, dumpsrno) => {
        setHeaderValuation(valuation)
        setHeaderIsd(isd);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
            branchCode: branch,
            isd: isd,
            dumpsrno: dumpsrno
        }
        Common.callApi(Common.apibalancesheet, [sid, "cnEvtmIsdCalculationView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmIsdCalculationData(resp.cnevtmisdcalculationdata);
            setScrMode("CNEVTM_ISD_CALCULATION")
            $(".loader").hide();
        })
    }
    const handleCnEvtmBranchWiseView = (srno, product, valuation) => {
        setHeaderProduct(product);
        setHeaderValuation(valuation);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "cnEvtmBranchWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmBranchWiseData(resp.cnevtmbranchwisedata);
            setScrMode("CNEVTM_BRANCH_WISE");
            $(".loader").hide();
        })
    }
    const handleCnEvtmBranchToIsdWiseView = (srno, product, branch, branchname) => {
        setHeaderBranch(branchname);
        $(".loader").show();
        const obj = {
            srno: srno,
            product: product,
            branchCode: branch
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "cnEvtmBranchToIsdWiseView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmBranchToIsdWiseData(resp.cnevtmbranchtoisdwisedata);
            setScrMode("CNEVTM_BRANCH_TO_ISD_WISE")
            $(".loader").hide();
        })
    }
    const handleCnEvtmBranchToIsdWiseCalculationView = (dumpsrno, branch, isd) => {
        $(".loader").show();
        const obj = {
            dumpsrno: dumpsrno,
            location: branch,
            isd: isd
        }
        Common.callApi(Common.apiRepStockValuation, [sid, "cnEvtmBranchToIsdWisecalculationView", JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setCnEvtmBranchToIsdWiseCalculationData(resp.cnevtmbranchtoisdwisecalculationdata);
            setScrMode("CNEVTM_BRANCH_TO_ISD_WISE_CALCULATION")
            $(".loader").hide();
        })
    }

    const handleViewDownload = (balancesheettype, generatetype) => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            balancesheettype: balancesheettype,
        }
        if (generatetype === 'D') {
            Common.callDownloadApiPost1(Common.apibalancesheet, "post", [sid, "download", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setMsgText(Common.buildMessageFromArray([result]));
                setMsgBox(true);
            });
        } else {
            Common.callApi(Common.apibalancesheet, [sid, "view", JSON.stringify(obj)], result => {
                var newWindow = window.open();
                newWindow.document.write(result);
                $(".loader").hide();
            });

        }

    }

    return (
        <div>
            {!props.hideLoginHeader &&
                <><LoginHeader />
                    <Menu />
                </>}


            <Container fluid>
                <>
                    {scrMode === "" ?
                        <>
                            <Row>
                                <Col>
                                    {!props.hideLoginHeader ? <h2>Stock Valuation<span style={{ color: "#f8f9fd" }}>{counter}</span> </h2> : null}
                                </Col>
                            </Row>&nbsp;
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={filterLocationType} onChange={handleLocationType}
                                            disabled={branchDisable === "true"}
                                            required>
                                            <option value="O">One</option>
                                            <option value="A">All</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {filterLocationType === 'O' ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={filterLocation}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleChangeLocation}
                                                isDisabled={branchDisable === "true"}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col></> : null}
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                        <Form.Select disabled={true} value={filterBalanceBookType} onChange={e => setFilterBalanceBookType(e.target.value)}
                                            required>
                                            <option value="T">Till Date</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {(filterBalanceBookType === 'P') ?
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                <DatePicker className="form-control"
                                                    selected={fromDate}
                                                    onChange={(date) => setFromDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </> : null}
                                {(filterBalanceBookType === 'T') || (filterBalanceBookType === 'P') ?
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>{filterBalanceBookType === 'T' ? 'Till Date' : 'To Date'}<span className="colorThemeRed">*</span></Form.Label><br />
                                            <DatePicker className="form-control"
                                                selected={toDate}
                                                onChange={(date) => setToDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col> : null}

                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-12 col-12'>
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                                    &nbsp;
                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleReportLog}>Reports Log</Button>
                                </Col>
                            </Row>
                        </> : null}
                    {scrMode === 'REPORT_GENERATION' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation Generated Successfully</h5>
                                <ul className='list-inline'>
                                    <li ><span onClick={() => handleCNVTMEVTMView()} className='colorThemeBlue pointer'><FontAwesomeIcon icon={faEye} /></span>  Stock Valuation</li> &nbsp;
                                </ul>
                            </Row>
                        </> : null}
                    {scrMode === 'ACTIVITY_LOG' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("")}>Back</Button>
                            <h4>Report Logs</h4>
                            <Row>
                                <Table responsive bordered striped >
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>From Date</th>
                                            <th>To Date</th>
                                            <th>Report Type</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            activityLogData.map((item, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td>&nbsp;</td>
                                                        <td>{item.trl_date}</td>
                                                        <td>{item.trl_time}</td>
                                                        <td>{item.trl_from_date}</td>
                                                        <td>{item.trl_to_date}</td>
                                                        <td>{item.trl_report_type === 'O' ? "Opening" : item.trl_report_type === 'P' ? 'Periodic' : 'Till Date'}</td>
                                                        <td>
                                                            {
                                                                <span onClick={() => handleActivityLogDetail(item.trl_srno)} className='colorThemeBlue pointer'>Details</span>
                                                            }
                                                        </td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                    </tbody>

                                </Table>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_VIEW' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("REPORT_GENERATION")}>Back</Button>&nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("STOCK", 'V')}>Print</Button> &nbsp;
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleViewDownload("STOCK", 'D')}>Download</Button>
                            <Row>
                                <h5>Stock Valuation</h5>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Actual </th>
                                                {/* <th>User</th> */}
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmGroupWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_product}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmIsdWiseView(item.trsv_srno, item.trsv_product, item.trsv_valuation)} className='colorThemeBlue pointer'>ISD</span>
                                                            }</td>
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmBranchWiseView(item.trsv_srno, item.trsv_product, item.trsv_valuation)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_ISD_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_VIEW")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation ISD Wise</h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>ISD</th>
                                                <th>Quantity </th>
                                                <th>Rate</th>
                                                <th>Valuation</th>
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmIsdWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_isd}</td>
                                                            <td>{item.trsv_remaining_qty}</td>
                                                            <td>{item.trsv_rate}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmIsdToBranchWiseView(item.trsv_srno, item.trsv_product, item.trsv_branch_code, item.trsv_isd, item.trsv_valuation)} className='colorThemeBlue pointer'>Branch</span>
                                                            }</td>
                                                            {branchDisable === "true" ?
                                                                <td>{
                                                                    <span onClick={() => handleCnEvtmIsdCalculations(item.trsv_srno, item.trsv_product, item.trsv_branch_code, item.trsv_isd, item.trsv_valuation, item.trsv_dump_srno)} className='colorThemeBlue pointer'>Calculations</span>
                                                                }</td>
                                                                : null}
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_ISD_TO_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_ISD_WISE")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation ISD To Branch Wise </h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>ISD : <b>{headerIsd} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Quantity </th>
                                                <th>Rate</th>
                                                <th>Valuation</th>
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmIsdToBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_branch}</td>
                                                            <td>{item.trsv_remaining_qty}</td>
                                                            <td>{item.trsv_rate}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <th></th>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_ISD_CALCULATION' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_ISD_WISE")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation ISD Calculation </h5>
                                {/* <Row>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Label>Product : {headerProduct}</Form.Label>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Valuation : <b>{headerValuation} </b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>ISD : <b>{headerIsd} </b></span>
                                                            </Col>
                                                        </Row> */}
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Type </th>
                                                <th>Srno</th>
                                                <th>Line no </th>
                                                <th>Value</th>
                                                <th>Rate</th>
                                                <th>Total inr</th>
                                                <th>Tran Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmIsdCalculationData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.branch}</td>
                                                            <td>{item.tsvc_type}</td>
                                                            <td>{item.tsvc_prd_srno}</td>
                                                            <td>{item.tsvc_line_no}</td>
                                                            <td>{item.tsvc_calculated_value}</td>
                                                            <td>{item.tsvc_rate}</td>
                                                            <td>{item.tsvc_calculated_inr}</td>
                                                            <td>{item.tsvc_prd_date}</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_BRANCH_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_VIEW")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation Branch Wise </h5>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>Branch</th>
                                                <th>Valuation</th>
                                                {/* <th>Profit & Loss</th> */}
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmBranchWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_branch}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            {/* <td>{item.trsv_profit_loss}</td> */}
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmBranchToIsdWiseView(item.trsv_srno, item.trsv_product, item.trsv_branch_code, item.trsv_branch)} className='colorThemeBlue pointer'>ISD</span>
                                                            }</td>
                                                            <th></th>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}
                    {scrMode === 'CNEVTM_BRANCH_TO_ISD_WISE' ?
                        <>
                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_BRANCH_WISE")}>Back</Button>
                            <Row>
                                <h5>Stock Valuation Branch To Isd Wise </h5>
                                <Row>
                                    <Col className="col-md-2 col-4">
                                        <span>Branch : <b>{headerBranch} </b></span>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Product : {headerProduct}</Form.Label>
                                    </Col>
                                    <Col className="col-md-2 col-4">
                                        <span>Valuation : <b>{headerValuation} </b></span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive bordered striped >
                                        <thead>
                                            <tr>
                                                <th>ISD</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Valuation</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cnEvtmBranchToIsdWiseData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.trsv_isd}</td>
                                                            <td>{item.trsv_remaining_qty}</td>
                                                            <td>{item.trsv_rate}</td>
                                                            <td>{item.trsv_valuation}</td>
                                                            <td>{
                                                                <span onClick={() => handleCnEvtmBranchToIsdWiseCalculationView(item.trsv_dump_srno, item.trsv_branch_code, item.trsv_isd)} className='colorThemeBlue pointer'>Calculation</span>
                                                            }</td>
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>

                                    </Table>
                                </Row>
                            </Row>
                        </> : null}{scrMode === 'CNEVTM_BRANCH_TO_ISD_WISE_CALCULATION' ?
                            <>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleBackScreenReportGeneration("CNEVTM_BRANCH_TO_ISD_WISE")}>Back</Button>
                                <Row>
                                    <h5>Stock Valuation Branch to ISD Wise  Calculation </h5>
                                    {/* <Row>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Label>Product : {headerProduct}</Form.Label>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Valuation : <b>{headerValuation} </b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>ISD : <b>{headerIsd} </b></span>
                                                            </Col>
                                                        </Row> */}
                                    <Row>
                                        <Table responsive bordered striped >
                                            <thead>
                                                <tr>
                                                    <th>Branch</th>
                                                    <th>Type </th>
                                                    <th>Srno</th>
                                                    <th>Line no </th>
                                                    <th>Value</th>
                                                    <th>Rate</th>
                                                    <th>Total inr</th>
                                                    <th>Tran Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    cnEvtmBranchToIsdWiseCalculationData.map((item, index) => (
                                                        <>
                                                            <tr key={index}>
                                                                <td>{item.branch}</td>
                                                                <td>{item.tsvc_type}</td>
                                                                <td>{item.tsvc_prd_srno}</td>
                                                                <td>{item.tsvc_line_no}</td>
                                                                <td>{item.tsvc_calculated_value}</td>
                                                                <td>{item.tsvc_rate}</td>
                                                                <td>{item.tsvc_calculated_inr}</td>
                                                                <td>{item.tsvc_prd_date}</td>
                                                            </tr>
                                                        </>
                                                    ))
                                                }
                                            </tbody>

                                        </Table>
                                    </Row>
                                </Row>
                            </> : null}
                </>
            </Container>

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>


            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </div>
    )
}

export default Rep_stock_valuation
